import React, { useState, useRef, useEffect } from 'react';
import { Input } from 'antd';
import styles from '../FolderTreeView.module.less';

interface InlineEditProps {
  value: string;
  onSave: (value: string) => void;
  onCancel: () => void;
  className?: string;
}

export const InlineEdit: React.FC<InlineEditProps> = ({
  value,
  onSave,
  onCancel,
  className = '',
}) => {
  const [editValue, setEditValue] = useState(value);
  const inputRef = useRef<any>(null);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  const handleSave = () => {
    if (editValue.trim() && editValue !== value) {
      onSave(editValue.trim());
    } else {
      onCancel();
    }
  };

  return (
    <Input
      ref={inputRef}
      className={`${styles.inlineEdit} ${className}`}
      value={editValue}
      onChange={(e) => setEditValue(e.target.value)}
      onBlur={handleSave}
      onPressEnter={handleSave}
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          onCancel();
        }
      }}
      onClick={(e) => e.stopPropagation()}
      maxLength={255}
    />
  );
};
